<template>
  <div class="m-view-block">
    <h2>{{ $t("home.blockTitle") }}</h2>
    <div class="block-area table-shadow">
      <div
        class="block-item flex-left"
        v-for="(item, index) in blockList"
        :key="index"
      >
        <router-link :to="`/block/${item.height}`" class="height-box">{{
          item.height
        }}</router-link>
        <div class="detail">
          <p>
            {{ $t("home.minerAdr") }}：
            <router-link
              :to="{ name: 'address', params: { address: item.minerHash } }"
              class="light hash"
              >{{ item.minerHash | filterHash(8) }}</router-link
            >
          </p>
          <p>
            <span class="light txcount"
              >{{ item.txs.length }}
              {{ item.txs.length == 1 ? $t("home.tx") : $t("home.txs") }}</span
            >
            <count class="count-down grey" :time="item.blockTime"></count>
          </p>
          <p>
            <span class="grey mine">{{ $t("home.mineRevenue") }}</span>
            <span>8 BTY</span>
            <span class="grey"
              >（{{ $t("home.miner") }} 5 + {{ $t("home.fund") }} 3）</span
            >
          </p>
        </div>
      </div>
      <router-link to="/blockList" class="viewall-btn flex-center">{{
        $t("home.viewAll")
      }}</router-link>
    </div>
  </div>
</template>

<script>
import blockBase from "@/mixins/Home/blockList.js";
import Count from "@/components/Count.vue";
export default {
  mixins: [blockBase],
  components: {
    Count,
  },
};
</script>

<style lang="scss" scoped>
.m-view-block {
  h2 {
    margin: 30px 0 20px 12px;
    font-size: 14px;
    font-family: PingFangSC-Semibold;
    font-weight: 500;
    color: $black;
    line-height: 20px;
  }
  .block-area {
    background: $white;
    .block-item {
      height: 100px;
      padding: 20px;
      border-bottom: 1px solid $border;
      .height-box {
        height: 51px;
        min-width: fit-content;
        padding: 0 10px;
        line-height: 51px;
        text-align: center;
        color: $white;
        font-size: 14px;
        background: $blue;
        border-radius: 2px;
      }
      .detail {
        margin-left: 15px;
        color: $black;
        font-size: 12px;
        line-height: 20px;
        .txcount {
          display: inline-block;
          min-width: 50px;
          margin-right: 10px;
        }
        .mine {
          display: inline-block;
          min-width: 50px;
          margin-right: 10px;
        }
        .grey {
          color: $grey;
        }
      }
    }
    .viewall-btn {
      height: 60px;
      font-size: 14px;
      // font-family: PingFangSC-Semibold;
      color: $orange;
    }
  }
}
</style>
